import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: '',
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({
        name: '',
        email: '',
        phone: '',
        service: '',
        message: '',
      });
    }, 3000);
  };

  return (
    <section className="contact" id="contact">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">Contact Us</span>
          <h2>Let's Work Together</h2>
          <p>
            Have a project in mind? Get in touch with us and let's make it
            happen.
          </p>
        </div>

        <div className="contact-wrapper">
          <div className="contact-info">
            <div className="contact-info-item">
              <div className="contact-info-icon">📍</div>
              <div className="contact-info-text">
                <h4>Our Office</h4>
                <p>
                  No.3 , JayChandi Mandir Road,Jaynagar Majilpur,Jaynagar,
                  <br />
                  South 24 Parganas, West Bengal 743337
                </p>
              </div>
            </div>

            <div className="contact-info-item">
              <div className="contact-info-icon">📞</div>
              <div className="contact-info-text">
                <h4>Call Us</h4>
                <p>
                  +91 9732001414
                  <br />
                  +91 9641867070
                </p>
              </div>
            </div>

            <div className="contact-info-item">
              <div className="contact-info-icon">✉️</div>
              <div className="contact-info-text">
                <h4>Email Us</h4>
                <p>
                splendidservices2016@gmail.com
                  {/* <br />
                  support@nexgenservices.com */}
                </p>
              </div>
            </div>

            <div className="contact-info-item">
              <div className="contact-info-icon">🕐</div>
              <div className="contact-info-text">
                <h4>Working Hours</h4>
                <p>
                  Mon - Sat: 9:00 AM - 7:00 PM
                  <br />
                  Sunday: By Appointment
                </p>
              </div>
            </div>

            <div className="contact-social">
              <a href="https://www.facebook.com/share/1CK76bPSRf/" className="social-link" aria-label="Facebook">
                f
              </a>
              {/* <a href="#!" className="social-link" aria-label="Twitter">
                𝕏
              </a>
              <a href="#!" className="social-link" aria-label="LinkedIn">
                in
              </a>
              <a href="#!" className="social-link" aria-label="Instagram">
                📷
              </a> */}
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            {submitted && (
              <div
                style={{
                  background: 'rgba(16, 185, 129, 0.2)',
                  border: '1px solid rgba(16, 185, 129, 0.4)',
                  padding: '15px',
                  borderRadius: '12px',
                  color: '#10b981',
                  textAlign: 'center',
                  marginBottom: '20px',
                  fontWeight: '600',
                }}
              >
                ✅ Thank you! Your message has been sent successfully.
              </div>
            )}

            <div className="form-row">
              <div className="form-group">
                <label>Full Name</label>
                <input
                  type="text"
                  name="name"
                  placeholder="John Doe"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Email Address</label>
                <input
                  type="email"
                  name="email"
                  placeholder="john@example.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Phone Number</label>
                <input
                  type="tel"
                  name="phone"
                  placeholder="+91 98765 43210"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Select Service</label>
                <select
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  required
                >
                  <option value="">Choose a service...</option>
                  <option value="event-management">Event Management</option>
                  <option value="memento-trophy">Memento & Trophy</option>
                  <option value="corporate-gifts">Corporate Gifts</option>
                  <option value="hospitality">
                    Hospitality Management
                  </option>
                  <option value="catering-facility">
                    Industrial Catering & Facility
                  </option>
                  <option value="graphic-design">Graphic Design</option>
                  <option value="business-consulting">
                    Business Consulting
                  </option>
                  <option value="govt-stationery">
                    Govt. Stationery Supply
                  </option>
                  <option value="software-development">
                    Software Development
                  </option>
                </select>
              </div>
            </div>

            <div className="form-group">
              <label>Your Message</label>
              <textarea
                name="message"
                placeholder="Tell us about your project or requirements..."
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>

            <button type="submit" className="form-submit">
              Send Message 🚀
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;